import { render } from "./Landing.vue?vue&type=template&id=67a420e8&scoped=true&lang=html"
import script from "./Landing.vue?vue&type=script&lang=js"
export * from "./Landing.vue?vue&type=script&lang=js"

import "./Landing.vue?vue&type=style&index=0&id=67a420e8&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-67a420e8"

export default script